import axios1 from "axios";


export default function($url){
    return axios1.get($url,);
}